import React from 'react';
import { Link } from "gatsby"

const Button = ({ children, color = 'holborn-green', href, ...props }) => {
    const baseClasses = 'py-2 px-8 rounded-3xl transition duration-500';
    const colorClasses = {
        // Green button with dark blue hover effect
        green: 'text-green-300 bg-green-300 hover:bg-green-300 hover:text-white border-green-300',
        'holborn-green': 'text-holborn-white bg-holborn-green hover:bg-holborn-blue',
        newsletter: 'text-green-300 bg-green-300 hover:bg-green-300 hover:text-white border-green-300',
        'holborn-newsletter': 'text-holborn-white bg-holborn-green hover:bg-holborn-blue w-full',
        // Green button with white hover effect
        greenWhite: 'text-holborn-white bg-holborn-green hover:bg-holborn-white hover:text-holborn-blue',
        'holborn-greenWhite': 'text-holborn-white hover:text-holborn-blue bg-holborn-green hover:bg-holborn-white',
         // Blue button with green hover effect
        blue: 'text-blue-300 bg-blue-300 hover:bg-blue-300 hover:text-white border-blue-300',
        'holborn-blue': 'text-holborn-white bg-holborn-blue hover:bg-holborn-green',
        whiteTransparent: 'text-white bg-transparent border border-solid border0white hover:bg-white hover:text-holborn-blue border-white',
        blueTransparent: 'text-blue bg-transparent border-2 border-solid border-holborn-blue hover:bg-blue hover:bg-holborn-blue hover:text-white',        
        whiteGreen: 'text-holborn-blue bg-holborn-white hover:bg-holborn-green hover:text-holborn-white',
        yellow: 'text-holborn-blue bg-holborn-yellow hover:bg-holborn-green hover:text-white border-holborn-yellow',
        // Add more colors as needed
    };
    
    const Component = href ? Link : 'button';

    // Ignore empty strings
    const colorClass = colorClasses[color] || colorClasses['holborn-green'];

    return (
        <Component to={href} className={`${baseClasses} ${colorClass}`} {...props}>
            {children}
        </Component>
    );
};

export default Button;
